namespace Gordic.Epk.WebControls.Sidebar {

    //TIP

    //var jQueryThis = ($(this) as any);
    //var formSelectorTemplate = "wfl-form:{0}|ixs-form:{1}";
    //var getFormSelector = function (ixp, ixsform) { return formSelectorTemplate.format(ixp, ixsform); };
    //jQueryThis.gcontent([Gordic.Report.WebClient.GReportFormControl, {
    //    autoLoadParams: {
    //        Form: getFormSelector(this.Ixp, this.IxsFrmGform),
    //        server: 'Gordic.Wfl.WebClient.GWflReportFormControl'
    //    },
    //    parentContent: this
    //}]).load();

    export class GEpkGfrmPanel {

        constructor() {
            if (this.service == null)
                this.service = new GContent("Gordic.Epk.WebControls.GEpkGfrmService");
        }

        /** nastala změna na GFRM sestavě */
        private changeOnGfrm: boolean;
        private tmpIxp: string;
        private service: GContent;
        private gfrmCnt: GContentType<any>;
        private gfrmElement: JQuery<HTMLElement>;

        public create(cnt: GContentType<any>, ixpForced?: string) {

            let panel = $("<div class='epk-gfrmpanel'>");

            return {
                icon: "gi-gfrm",
                customDiv: panel,
                minWidth: 300,
                id: "panelGfrmForm",
                caption: "jres:32000808",				//RC 32000808 : Interní formulář
                leaf: "jres:32000808",					//RC 32000808 : Interní formulář
                open: (ev, obj) => {
                    var ixp = this.getIxp(cnt, ixpForced);
                    if (ixp === this.tmpIxp) {
                        console.log("Vykreslený panel s tímto identifikátorem byl již použit.");
                        return;
                    }
                    else
                        this.loadPanel(cnt, panel, ixp);

                    saveToUserSettings(cnt.userSettings!, "leftSidebar.panelGfrmFormDetailOpen", true);
                },
                close: () => {
                    if (cnt.closed)
                        return;
                    saveToUserSettings(cnt.userSettings!, "leftSidebar.panelGfrmFormDetailOpen", false);
                }
            } as GSideBarPanelOptions;
        }

        /**
         * načtení či reload panelu
         * @param cnt
         * @param element
         * @param ixp
         */
        public loadPanel(cnt: GContentType<any>, element: JQuery<HTMLElement>, ixp: string) {
            this.changeOnGfrm = false;
            this.getIxsFrm(ixp)
                .then((ixsform) => {
                    element.empty();                            // vyčištění contentu
                    if (ixsform != null && ixsform !== "") 
                        this.customLoadSidebar(cnt, element, { ixp: ixp, ixsform: ixsform });
                    else 
                        $("<div class='epk-nahled-sidebar-class'>").text("jres:32000813").appendTo(element); //RC 32000813 : Interní formulář není k dispozici.
                })
                .done(() => {
                    this.tmpIxp = ixp;  // uložení nového ixp do tempu, kvůli opakovanému načtení
                })
        }

        /**
         * spustit operaci pro uložení GFRM a získání GUID k vyexportovanému PDF
         * @param epk_gfrmzobr
         * @param akce_epk
         */
        public run(epk_gfrmzobr: number, akce_epk: Wfl.Interface.GEpkWflcsaeEnum) {
            if (epk_gfrmzobr === 1) {               // musí být zobrazen GFRM panel
                if (this.changeOnGfrm === true) {   // pokud došlo ke změně na sestavě, uložím sestavu a provedu export do PDF
                    if (akce_epk === Wfl.Interface.GEpkWflcsaeEnum.KonverzeFormulareSpojeniSObrazem)
                        return this.saveAll();
                    else
                        return this.saveGfrm();     // pokud nebude sloučení, uložím pouze GFRM 
                }
                else {          // nedojde k editaci, ale může dojít ke sloučení, pokud je aktivní akce_epk
                    if (akce_epk === Wfl.Interface.GEpkWflcsaeEnum.KonverzeFormulareSpojeniSObrazem)
                        return this.savePdf();
                }
            }
            return $.Deferred().resolve(null).promise();
        }

        /** proběhne jak uložení GFRM, tak export do PDF */
        protected saveAll() {
            var dfd = $.Deferred();
            this.saveGfrm()
                .then(() => {
                    return this.savePdf();
                })
                .done((saveDto) => {
                    dfd.resolve(saveDto);
                })
            return dfd.promise();
        }

        /** proběhne pouze uložení GFRM */
        protected saveGfrm() {
            var cnt = this.getGfrmContent();
            if (cnt != null) {
                return cnt.save()  // uložení GFRM formuláře
            }
            return $.Deferred().resolve(null).promise();
        }

        /** proběhne pouze export do PDF */
        protected savePdf() {
            var cnt = this.getGfrmContent();
            if (cnt != null) 
                return cnt!.savepdf(true)  // uložení PDF bez stažení
            return $.Deferred().resolve(null).promise();
        }

        //#region -- PRIVATE METHODS --

        private getIxsFrm(ixp: string): JQuery.Promise<string> {
            if (ixp == null) {
                // thazmuka (27.4.2022) - neexistuje žádný identifikátor, takže se nepokouším načíst interní formulář
                // podmínka přidána kvůli problému při seskupení
                return $.Deferred().resolve(null).promise();
            }
            return this.service.call("DefaultLoadIxsFrm", { ixp: ixp });
        }

        private customLoadSidebar(cnt: GContentType<any>, element: JQuery<HTMLElement>, opt: { ixp: string, ixsform: string }) {

            if (this.gfrmElement != null)
                this.gfrmElement.remove();

            this.gfrmElement = $("<div class='epk-gfrm'>").appendTo(element);
            this.gfrmElement.gcontent([Gordic.Report.WebClient.GReportFormControl, {
                autoLoadParams: {
                    Form: this.getFormSelector(opt.ixp, opt.ixsform),
                    server: 'Gordic.Wfl.WebClient.GWflReportFormControl'
                },
                parentContent: cnt
            }]);
           // (this.gfrmElement as any).load();
            this.gfrmCnt = $.content(this.gfrmElement);

            this.zaregistrujTrigeryNaGFRM(this.gfrmElement);
        }

        private zaregistrujTrigeryNaGFRM(element: JQuery<HTMLElement>) {
            var that = this;
            element.on("greportformcontrolsaved", function (ev, obj) {
                if (obj && obj.reloadovatPoUlozeni) {
                    obj.reloadovatPoUlozeni = false;
                }
            });
            element.on("greportformcontrolchanged", function (ev, obj) {
                that.changeOnGfrm = true;
            });
        }

        private getGfrmContent() {
            if (this.gfrmCnt == null)
                return null;
            return this.gfrmCnt;
        }

        private getIxp(cnt: GContentType<any>, ixpForced?: string) {
            /** identifikátor dokumentu */
            let ixp: string = "";
            if (ixpForced != null)
                ixp = ixpForced;
            else if (cnt.grid != null) {
                var row = cnt.grid.ggrid("activeRow");
                ixp = row != null && row.ixp != null ? row.ixp : "";
            }
            return ixp;
        }

        private getFormSelector(ixp: string, ixsform: string) {
            var formSelectorTemplate = "wfl-form:{0}|ixs-form:{1}";
            return formSelectorTemplate.format(ixp, ixsform);
        }

        //#endregion

    }

}